import React, { Component } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    CircularProgress
} from '@material-ui/core';
import { Delete, Save, Cancel, ArrowBack } from '@material-ui/icons';
import moment from 'moment';
import { getEmployeeVacationsUseCase } from '../services/getEmployeeVacationsUseCase';
import { addEmployeeVacationUseCase } from '../services/addEmployeeVacationUseCase';
import { deleteEmployeeVacationUseCase } from '../services/deleteEmployeeVacationUseCase';

class EmployeeVacationsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vacations: [],
            loading: true,
            addingNew: false,
            newVacation: {
                startDate: '',
                endDate: '',
                description: ''
            }
        };
    }

    componentDidMount() {
        this.loadVacations();
    }

    loadVacations = async () => {
        this.setState({ loading: true });
        try {
            const { employee } = this.props;
            const vacations = await getEmployeeVacationsUseCase(employee.dni);
            this.setState({ vacations, loading: false });
        } catch (error) {
            console.error('Error loading vacations:', error);
            this.setState({ loading: false });
        }
    }

    handleAddNew = () => {
        this.setState({ addingNew: true });
    }

    handleCancelAdd = () => {
        this.setState({
            addingNew: false,
            newVacation: {
                startDate: '',
                endDate: '',
                description: ''
            }
        });
    }

    handleSaveNew = async () => {
        const { newVacation } = this.state;
        const { employee } = this.props;

        // Validation
        if (!newVacation.startDate || !newVacation.endDate) {
            alert('Las fechas de inicio y fin son obligatorias');
            return;
        }

        const startDate = moment(newVacation.startDate);
        const endDate = moment(newVacation.endDate);

        if (endDate.isBefore(startDate)) {
            alert('La fecha de fin no puede ser anterior a la fecha de inicio');
            return;
        }

        try {
            await addEmployeeVacationUseCase({
                employeeDni: employee.dni,
                startDate: startDate.toDate(),
                endDate: endDate.toDate(),
                description: newVacation.description
            });

            this.setState({
                addingNew: false,
                newVacation: {
                    startDate: '',
                    endDate: '',
                    description: ''
                }
            });

            // Reload vacations
            this.loadVacations();
        } catch (error) {
            console.error('Error adding vacation:', error);
            alert('Error al añadir vacaciones');
        }
    }

    handleDelete = async (vacationId) => {
        if (window.confirm('¿Está seguro de eliminar este periodo de vacaciones?')) {
            try {
                await deleteEmployeeVacationUseCase(vacationId);
                this.loadVacations();
            } catch (error) {
                console.error('Error deleting vacation:', error);
                alert('Error al eliminar vacaciones');
            }
        }
    }

    handleNewChange = (field, value) => {
        this.setState({
            newVacation: {
                ...this.state.newVacation,
                [field]: value
            }
        });
    }

    render() {
        const { employee } = this.props;
        const { vacations, loading, addingNew, newVacation } = this.state;

        return (
            <Box>
                <Box display="flex" alignItems="center" mb={2}>
                    <IconButton onClick={this.props.onBack} color="primary" size="small" style={{ marginRight: '8px' }}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6">
                        Vacaciones de: {employee.name}
                    </Typography>
                </Box>

                <div style={{ marginBottom: '16px', textAlign: 'right' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleAddNew}
                        disabled={addingNew}
                    >
                        Añadir Vacaciones
                    </Button>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Paper style={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Día de comienzo</strong></TableCell>
                                    <TableCell><strong>Día de final</strong></TableCell>
                                    <TableCell><strong>Descripción</strong></TableCell>
                                    <TableCell align="right"><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addingNew && (
                                    <TableRow style={{ backgroundColor: '#e3f2fd' }}>
                                        <TableCell>
                                            <TextField
                                                type="date"
                                                value={newVacation.startDate}
                                                onChange={(e) => this.handleNewChange('startDate', e.target.value)}
                                                size="small"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                type="date"
                                                value={newVacation.endDate}
                                                onChange={(e) => this.handleNewChange('endDate', e.target.value)}
                                                size="small"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newVacation.description}
                                                onChange={(e) => this.handleNewChange('description', e.target.value)}
                                                size="small"
                                                fullWidth
                                                placeholder="Ej: Vacaciones Verano"
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={this.handleSaveNew} color="primary" size="small">
                                                <Save />
                                            </IconButton>
                                            <IconButton onClick={this.handleCancelAdd} size="small">
                                                <Cancel />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {vacations.map((vacation) => (
                                    <TableRow key={vacation.id}>
                                        <TableCell>
                                            {moment(vacation.startDate).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>
                                            {moment(vacation.endDate).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>{vacation.description || '-'}</TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                onClick={() => this.handleDelete(vacation.id)}
                                                color="secondary"
                                                size="small"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {vacations.length === 0 && !addingNew && (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography color="textSecondary">
                                                No hay vacaciones registradas para este empleado
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                )}
            </Box>
        );
    }
}

export default EmployeeVacationsView;
